import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { apiRoutes } from "../../hooks/apiClient";
import OrigemSpfPaginatedView from "../../components/UI/PaginatedView/OrigemSpfPaginatedView";
import { formatarData } from "../../components/Formatters/DateTime";

const OrigemProcedimentoFiscal = ({ history, location }) => {
  const [title, setTitle] = useState("");
  const { state } = location;

  const columns = [
    {
      name: `Nº da ${title}`,
      selector: (row) => row.sequencial,
      maxWidth: "200px",
      sortable: true,
      center: true,
    },
    {
      name: "Inscrição Estadual",
      selector: (row) => row.incricaoEstadual,
      maxWidth: "180px",
      sortable: true,
      center: true,
    },
    {
      name: "CNPJ/CPF",
      selector: (row) => row.cpfCnpj,
      maxWidth: "180px",
      sortable: true,
      center: true,
    },
    {
      name: "Razão Social",
      selector: (row) => row.nomeFormal,
      maxWidth: "100%",
      sortable: true,
    },
    {
      name: "Data de Inclusão",
      cell: (row) => formatarData(row.dataInclusao),
      maxWidth: "180px",
      selector: "dataInclusao",
      sortable: true,
      center: true,
    },
  ];

  useEffect(() => {
    if (state && state.tipoOrigem) {
      if (state.tipoOrigem === "D") setTitle("Denúncia");
      else if (state.tipoOrigem === "C") setTitle("Cobrança");
      else setTitle("Parte de Serviço");
    }
  }, [state]);

  return (
    <>
      <Row>
        <Col sm="12">
          <h1 className="h3 mb-4 text-gray-800">{`Solicitação de Procedimento Fiscal - ${title}`}</h1>
        </Col>
      </Row>

      <OrigemSpfPaginatedView
        title={title}
        keyField="sequencial"
        descriptionField="sequencial"
        defaultSearch
        defaultSearchPlaceholder={`Digite o Nº da ${title}`}
        queryService={apiRoutes.fiscalizacao.procedimentoFiscal.listaOrigem}
        editRoute="/app/spf/form"
        columns={columns}
        advancedParameters={state}
        history={history}
      />
      <Row>
        <Col sm="12">
          <Button variant="danger" onClick={() => history.goBack()}>
            Cancelar
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default OrigemProcedimentoFiscal;
